import styled from "styled-components";
import {Avatar} from "antd";

export const MarkerContainer = styled.div`
    position: absolute;
    border-radius: 50%;
    width: 20px;
    max-height: 20px;
    background-color: ${props => props.color};
    transform: translate(-48%, -115%) rotate(45deg);
    border: 1px solid
        ${props => (props.color === "#4C9E7D" || props.color === "#D85E5A" ? "white" : "black")};
    box-sizing: content-box;
    cursor: pointer;
    border-bottom-right-radius: 2%;
    z-index: ${props => props.zIndex};
`;

export const MarkerIcon = styled(Avatar)`
    width: 20px;
    height: 20px;
    background-color: transparent;
    color: ${props => (props.color === "#4C9E7D" || props.color === "#D85E5A" ? "white" : "black")};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px !important;
    transform: rotate(-45deg);
`;
